import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	teamType: {
		id: 'servicedesk-project-department-type-select.project-department-type-free-text.team-type',
		defaultMessage: 'Tell us your team type',
		description:
			'Label for free text field where user can input the department their team works in.',
	},
	tooltip: {
		id: 'servicedesk-project-department-type-select.project-department-type-free-text.tooltip',
		defaultMessage: 'Your information will be kept safe in accordance with our privacy policy.',
		description: 'Disclaimer message for the free text field that a user can type into.',
	},
	learnMore: {
		id: 'servicedesk-project-department-type-select.project-department-type-free-text.learn-more',
		defaultMessage: 'Read Atlassian’s privacy policy',
		description:
			'Link that gives further context and information to the user about the disclaimer.',
	},
	learnMoreAriaLabelText: {
		id: 'servicedesk-project-department-type-select.project-department-type-free-text.learn-more-aria-label-text',
		defaultMessage: 'Learn more about team types',
		description:
			'With this aria-label text, screen reader users will understand the purpose of the link',
	},
});
